import { createFileRoute, redirect } from '@tanstack/react-router';

import { paths } from 'src/routes/paths';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/settings/account')({
  beforeLoad: () => {
    throw redirect({
      to: paths.dashboard.settings.profile,
    });
  },
});
